import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { ReportFilter } from '../../ReportFilter'
import { ReportFilterStore } from '../../ReportFilterStore'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { SalesTrendsCards } from './SalesTrendsCards'
import { Skeleton } from 'antd-v4'

export const SalesTrendsReport: React.FC<{
  currentCompanyStore: CurrentCompanyStore
  reportFilterStore: ReportFilterStore
}> = inject(
  'currentCompanyStore',
  'reportFilterStore',
)(
  observer(({ currentCompanyStore, reportFilterStore }) => {
    const { startDateString, endDateString, selectedLocationIds } = reportFilterStore
    const { company } = currentCompanyStore

    if (!company) {
      return <Skeleton active />
    }

    return (
      <>
        <ReportFilter />

        <SalesTrendsCards
          companyId={company.id}
          locationIds={selectedLocationIds}
          startDate={startDateString}
          endDate={endDateString}
        />
      </>
    )
  }),
)
